import { render, staticRenderFns } from "./SelectCheckBox.vue?vue&type=template&id=92c2ed90&scoped=true"
import script from "./SelectCheckBox.vue?vue&type=script&lang=ts"
export * from "./SelectCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectCheckBox.vue?vue&type=style&index=0&id=92c2ed90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c2ed90",
  null
  
)

export default component.exports